import React from 'react';
import TreeMenu from '../../common/TreeMenu';
import usePermission from '../../../hooks/usePermission';

function DashboardLayout() {
  const dataTree = [
    {
      id: 'DASHBOARD',
      title: 'Dashboard',
      url: '/dashboard',
    },
  ];

  usePermission(['ROLE_ADMIN']);

  return (
    <div className='h-screen'>
      <TreeMenu dataTree={dataTree} />;
    </div>
   
)}

export default DashboardLayout;
